import gql from 'graphql-tag';
import { RichTextBlock } from 'prismic-reactjs';
import { IImage, ILink } from 'utils/types';
import { IBaseSlice, SliceTypes } from '..';
import { parser } from '../../utils/parsers';
import { PrismicImage, PrismicLink } from '../../utils/PrismicTypes';

export interface IText extends IBaseSlice {
  type: SliceTypes;
  tagline?: string;
  title?: string;
  heading?: RichTextBlock[];
  text: RichTextBlock[];
  columns?: number;
  color?: string;
  image?: IImage;
  link?: ILink;
  label?: string;
  aside?: RichTextBlock[];
}

export const fragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_text
      }
    }
  }
`;

export const customPageFragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_tagline
        slice_title
        slice_text
        slice_columns
        slice_color
        slice_image
        slice_link { ...Link }
        slice_buttonlabel
        slice_aside
      }
    }
  }
`;

export const customSplitPageFragment = (name: string, type: string, fragmentName: string) => gql`
  fragment ${fragmentName || name} on ${type} {
    ... on ${type}${name} {
      type
      primary {
        slice_tagline
        slice_title
        slice_text
      }
    }
  }
`;

type Props = {
  primary: {
    slice_tagline?: RichTextBlock[];
    slice_title?: RichTextBlock[];
    slice_text: RichTextBlock[];
    slice_columns?: string;
    slice_color?: string;
    slice_image?: PrismicImage;
    slice_link?: PrismicLink;
    slice_buttonlabel?: RichTextBlock[];
    slice_aside?: RichTextBlock[];
  };
};

const COLUMNS = {
  'Single column': 1,
  'Two column': 2,
  'Three column': 3,
};

export const parse = (slice: Props, redirects): IText => ({
  type: SliceTypes.Text,
  tagline: parser.string(slice.primary.slice_tagline),
  title: parser.string(slice.primary.slice_title),
  heading: parser.richText(slice.primary.slice_title, redirects),
  text: parser.richText(slice.primary.slice_text, redirects),
  columns: COLUMNS[slice.primary.slice_columns] ?? null,
  color: parser.string(slice.primary.slice_color),
  image: parser.image(slice.primary.slice_image),
  link: parser.link(slice.primary.slice_link, redirects),
  label: parser.string(slice.primary.slice_buttonlabel),
  aside: parser.richText(slice.primary.slice_aside, redirects),
});
